import {connect} from "react-redux"
import {getLowerHeaderHeight} from "../../utils/getHeaderHeight"
import {State} from "../../ducks"
import {setPrimaryNavIndex, setIsInPrimaryNav} from "../../ducks/primary-nav"

export const mapStateToProps = (state: State) => {
    const {template} = state.settings

    const headerHeights = getLowerHeaderHeight(template)

    return {
        mobileHeight: headerHeights.mobile,
        desktopHeight: headerHeights.desktop,
        templating: state.template,
    }
}

export const mapDispatchToProps = dispatch => ({
    closeNav: (e): void => {
        if (e.currentTarget.scrollLeft !== 0) {
            dispatch(setPrimaryNavIndex(-1, ""))
            dispatch(setIsInPrimaryNav(false))
        }
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
